// eslint-disable-next-line import/prefer-default-export
export function copyToClipboard(copyContent) {
  const dummyTextArea = document.createElement('textarea');
  document.body.appendChild(dummyTextArea);
  dummyTextArea.value = copyContent;
  dummyTextArea.select();
  document.execCommand('copy');
  document.body.removeChild(dummyTextArea);
}
